import { ScriptError } from '@/types/errors';
import { loadScript } from './scriptLoader';
import { sha256 } from 'js-sha256';
type RedditPixelAction = 'init' | 'track';
type RedditPixelInit = Record<string, string>;

interface RedditPixelFunction {
	(action: 'init', pixelId: string, config?: RedditPixelInit): void;
	(action: 'track', event: string): void;
	sendEvent?: (action: RedditPixelAction, ...args: unknown[]) => void;
	callQueue: [RedditPixelAction, ...unknown[]][];
	pixelId?: string;
}

export function initializeRedditPixel(pixelId: string, config?: RedditPixelInit): Promise<void> {
	if (window.rdt) return Promise.resolve(); // Skip if Reddit Pixel is already initialized

	const rdt = function (action: RedditPixelAction, ...args: unknown[]) {
		if (rdt.sendEvent) {
			rdt.sendEvent(action, ...args);
		} else {
			rdt.callQueue.push([action, ...args]);
		}
	} as RedditPixelFunction;

	rdt.callQueue = [];
	rdt.pixelId = pixelId;
	window.rdt = rdt;

	return new Promise((resolve, reject) => {
		loadScript(
			{
				src: 'https://www.redditstatic.com/ads/pixel.js',
				bundleId: 'reddit-pixel',
				success: () => {
					try {
						window.rdt('init', pixelId, config);
						window.rdt('track', 'PageVisit');
						resolve();
					} catch (error) {
						reject(new ScriptError(error as Error));
					}
				},
				error: () => {
					// loadScript will handle error reporting to Sentry
					reject(new ScriptError('Failed to load Reddit Pixel script'));
				},
			},
			'Reddit Pixel',
		);
	});
}

export function logRedditPixelConversions({
	email,
	conversionId,
	hasPixel,
}: {
	email: string;
	conversionId: string;
	hasPixel: boolean;
}) {
	window.rdt('track', 'SignUp', {
		emailHash: sha256(email),
		connection_id: conversionId,
	});

	if (hasPixel) {
		window.rdt('track', 'Lead', {
			emailHash: sha256(email),
			connection_id: conversionId,
		});
	}
}
